// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "label-1YRt-";
var _3 = "checked-3-CYH";
var _4 = "error-ArwBv";
export { _1 as "__esModule", _2 as "label", _3 as "checked", _4 as "error" }
export default { "__esModule": _1, "label": _2, "checked": _3, "error": _4 }
